// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/baloa-background-login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-form-panel__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    height: 150vh;
    background-color: var( --white-color );
}

.signup-form-panel__container__left-col {
    grid-area: left;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 150vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.signup-form-panel__container__right-col {
    grid-column: 6 / 12;
    margin-top: 175px;
    margin-bottom: 12px;
}

.signup-form-panel__container__right-col .baloa-headline-1 {
    color: var(--primary-very-dark-color);
    text-align: start;
}

.signup-form-panel__profile-photo {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.signup-form-panel__profile-photo .baloa-normal {
    font-weight: var(--font-medium);
    color: var(--primary-dark-color);
    margin-top: var(--space-x2);
    margin-bottom: var(--space-half);
}

.signup-form-panel__profile-photo_box{
    position: relative;
}

.signup-form-panel__profile-photo__container {
    width: 124px;
    height: 124px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.signup-form-panel__profile-photo__container .hubicon-default_pp {
    font-size: 124px;
    color: var(--primary-dark-color);
}

.signup-form-panel__profile-photo__container_plus{
    background-color: var(--new-green-color);
    width: 31px;
    height: 31px;
    border-radius: 50%;
    position: absolute;
    top: 96px;
    left: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.signup-form-panel__profile-photo__container_plus.baloa-subtitle-2{
    color: var(--white-color);
    font-weight: var(--font-medium);
}

.signup-form-panel__profile-photo__container_plus:hover{
    cursor: pointer;
}

.signup-form-panel__profile-photo__upload.baloa-names {
    color: var(--new-green-color);
    margin-top: var(--space-half-quarter);
    cursor: pointer;
}

.signup-form-panel__form__first-last-name__container {
    display: flex;
    justify-content: space-between;
}

.signup-form-panel__form__birth-day-username__container {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--space);
}

.signup-form-panel__form__birth-day-username__container div {
    width: 100%;
}

.signup-form-panel__form__birth-day-username__container__birth-day {
    margin-left: var(--space-half-quarter);
}

.signup-form-panel__form__birth-day-username__container__username {
    margin-right: var(--space-half-quarter);
}

.signup-form-panel__form__first-last-name__container .input-field {
    width: 100%;
}

.signup-form-panel__form__first-last-name__container .input-field:first-of-type {
    margin-right: var(--space-half-quarter);
    margin-top: 72px;
}

.signup-form-panel__form__first-last-name__container .input-field:last-of-type {
    margin-left: var(--space-half-quarter);
    margin-top: 72px;
}

.signup-form-panel__form__first-last-name__container .input-field .input-field-input{
    background-color: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 9px;
}

.signup-form-panel__form__first-last-name__container .input-field .input-field-label{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
    font-size: var(--space);
}

.input-field.signup-form-panel__form__username {
    margin-bottom: var(--space-half-quarter);
}

.signup-form-panel__form__birth-day-username__container .input-field {
    margin-top: var(--space-half-quarter);
}

.signup-form-panel__form__birth-day-username__container .input-field .input-field-input{
    background-color: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 9px;
}

.signup-form-panel__form__birth-day-username__container .input-field .input-field-label{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
    font-size: var(--space); 
}


button.button.primary-button.signup-form-panel__form__submit {
    margin-left: auto;
    margin-top: var(--space-x2);
}

.signup-form-panel__form__birth-day-username__container__username-tip.baloa-names {
    color: var(--new-green-color);
    font-weight: var(--font-regular);
}

.signup-form-panel__form__birth-day-username__container__username .baloa-names:last-of-type {
        font-weight: var(--font-regular);
}

.signup-form-panel__profile-photo__container img {
    width: 124px;
    height: 124px;
    border-radius: 50%;
}

.signup-form-panel__container__left-col img {
    width: 181px;
    margin-top: 68px;
    margin-left: var(--space-x3);
}
.signup-form-panel__container__right_back-option{
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: var(--space);
}

.signup-form-panel__form__role_container{
    display: flex;
    gap: var(--space-and-half);
    justify-content: space-between;
}

.signup-form-panel__form__profile-role{
    width: 50%;
}

.profile-role-selector__select-input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before {
    border: none !important;
}
.profile-role-selector__select-input .MuiInput-underline.select-field-input:before {
    border: none;
    transition: none;
}
.profile-role-selector__select-input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused {
    border-style: none !important;
}

.profile-role-selector__select-input .MuiListItemText-multiline .MuiListItemText-secondary {
    display: none;
}

.profile-role-selector__select-input .MuiListItemText-multiline .baloa-table{
    color: var(--primary-very-dark-color);
}

.profile-role-selector__select-input .MuiSelect-select:focus {
    background-color: unset;
}

.profile-role-selector__select-input .select-field-input,
.profile-profession-selector__select-input .select-field-input{
    background-color: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 9px;
}

.profile-profession-selector__select-input.input-field-autocomplete__list {
    margin-left: 16px;
    margin-top: 7px;
    margin-bottom: 7px;
}

.signup-form-panel__form__profile-role .select-field.profile-role-selector__select-input{
    margin: 0;
}

.profile-role-selector__select-input .select-field-clean__icon-list.icon-coach{
    color: var(--primary-very-dark-color);
}

.signup-form-panel__form__profile-role .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root{
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 9px;
}

.signup-form-panel__form__profile-role .profile-profession-selector__select-input{
    margin-top: 11px;
}

.signup-form-panel__form__profile-role .input-field-autocomplete label{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
    font-size: var(--space);
    text-transform: inherit;
}

.signup-form-panel__form__profile-role_label_tooltip{
    display: flex;
    gap: var(--space-quarter);
    align-items: center;
}

.signup-form-panel__form__profile-role_label_tooltip .label_tooltip.baloa-table{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
}

.signup-form-panel__form__input_grid-tooltip{
    display: flex;
}

.signup-form-panel_tooltip {
    position: relative;
    display: inline-block;
}

.signup-form-panel_tooltip .signup-form-panel_tooltiptext {
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    visibility: hidden;
    width: 20rem;
    background: var(--white-color);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    border-radius: 6px;
    padding: 10px;
    position: absolute;
    left: -152px;
    top: -192px;
    z-index: 1;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
}

.signup-form-panel_tooltiptext .baloa-username{
    color: var(--primary-dark-color);
}

.signup-form-panel_tooltiptext .baloa-table{
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
    margin-left: var(--space-quarter);
}

.signup-form-panel_tooltiptext_grid_title{
    display: flex;
    align-items: baseline;
}

.signup-form-panel_tooltip:hover{
    cursor: pointer;
}

.signup-form-panel_tooltip:hover .signup-form-panel_tooltiptext {
    visibility: visible;
}

.signup-form-panel_tooltiptext::after{
    content: "";
    position: absolute;
    bottom: -10px;
    left: 50%;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid var(--white-color);
    transform: translateX(-50%);
}

.signup-form-panel__form__profile-role .MuiAutocomplete-listbox {
    padding: 8px;
}

.signup-form-panel__form__claim-account-file {
    margin-top: 24px;
}

.signup-form-panel__form__claim-account-file .baloa-names {
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.signup-form-panel__form__claim-account-file .baloa-table {
    color: var(--basic-gray-color);
    margin-top: 4px;
}

.signup-form-panel__form__claim-account-file .upload-file-button {    
    border-radius: 6px;
    border: 1px solid var(--new-gray-background-color);
    background: var(--white-color);
    color: var(--new-green-color);
    margin-right: 12px;
}

.upload-file-button .icon {
    grid-area: icon;
    margin-right: 10px;
}

.signup-form-panel__form__claim-account-file .hubicon-upload::before {
    color: var(--new-green-color);
}

.signup-form-panel__form__claim-account-file .baloa-table-column {
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.signup-form-panel__form__claim-account-file__button {
    margin-top: 12px;
    display: flex;
    align-items: center;
}

.signup-form-panel__form__claim-account-file__button .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
}

.signup-form-panel__form__claim-account-file__button .hubicon-clear_option {
    background: var(--new-gray-color);
    border-radius: 50%;
    padding: 5px;
    margin-left: 12px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .signup-form-panel__container {
        display: block;
        height: 100vh;
    } 
    .signup-form-panel__container__left-col {
        height: 0;
        background-image: none;
    }
    .signup-form-panel__container__left-col a {
        display: flex;
        justify-content: center;
    }
    .signup-form-panel__container__left-col img {
        width: 100px;
        margin-top: calc( var(--space-x3) + var(--space-quarter) + var(--space-eighth) );
        margin-left: 0;
    }
    .signup-form-panel__container__right-col {
        margin-top: 0;
        background-color: var(--white-color);
        top: 117px;
        position: absolute;
        z-index: 1;
        width: 100%;
        padding-bottom: var(--space);
    }    
    .form.signup-form-panel__form {
        
        margin: var(--space);
        width: 92%;
    }
    .signup-form-panel__container__right-col .baloa-headline-1 {
        color: var(--primary-very-dark-color);
    }
    .signup-form-panel__profile-photo .baloa-normal {        
        color: var(--primary-dark-color);
        margin-top: 0;   
    }
    .signup-form-panel__profile-photo__container {
        width: 80px;
        height: 80px;        
    }
    .signup-form-panel__profile-photo__container .hubicon-default_pp {
        font-size: 80px;
    }
    .signup-form-panel__profile-photo__upload.baloa-names {
        margin-top: var(--space-half);
    }
    .signup-form-panel__form__first-last-name__container {
        flex-direction: column;
    }
    .signup-form-panel__form__first-last-name__container .input-field:first-of-type {
        margin-right: 0; 
        margin-top: var(--space-x3);
        margin-bottom: 0;
    }
    .signup-form-panel__form__first-last-name__container .input-field:last-of-type {
        margin-left: 0;
        margin-top: var(--space-x3);
    }
    .signup-form-panel__form__birth-day-username__container {
        flex-direction: column;
        margin-bottom: 0;
    }
    .signup-form-panel__form__date-field .input-field-input  {
        width: 100%;
    }
    .signup-form-panel__form__birth-day-username__container__username {
        margin-left: 0;
    }
    .signup-form-panel__form__birth-day-username__container__username-tip.baloa-names,
    .signup-form-panel__form__birth-day-username__container__username .baloa-names:last-of-type {
        font-weight: var(--font-regular);
    }
    button.button.primary-button.signup-form-panel__form__submit {
        width: 100%;
        margin-top: calc( var(--space-x3) + var(--space-half-quarter) + var(--space-eighth) );
    }
    .signup-form-panel__profile-photo__container img {
        width: 80px;
        height: 80px;
    }
    .input-field.signup-form-panel__form__username {
        margin-bottom: 0;
    }
    .signup-form-panel__container__right-_back-option{
        margin-left: var(--space-half);
    }
    .signup-form-panel__profile-photo__container_plus{
        width: 24px;
        height: 24px;
        top: 58px;
        left: 56px;
    }
    .signup-form-panel__form__birth-day-username__container__birth-day {
        margin-left: 0px;
        margin-top: var(--space-and-half);
    }
    .signup-form-panel__form__birth-day-username__container__birth-day .input-field{
        margin: var(--space) 0;
    }
    .signup-form-panel__form__role_container{
        display: flex;
        flex-direction: column;
    }
    .signup-form-panel__form__profile-role{
        width: 100%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signup-form-panel/SignUpFormPanelComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,yDAA6E;IAC7E,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,uBAAuB;AAC3B;;;AAGA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;QACQ,gCAAgC;AACxC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,oCAAoC;IACpC,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,oDAAoD;AACxD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,8BAA8B;IAC9B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;QACd,aAAa;IACjB;IACA;QACI,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,gFAAgF;QAChF,cAAc;IAClB;IACA;QACI,aAAa;QACb,oCAAoC;QACpC,UAAU;QACV,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,4BAA4B;IAChC;IACA;;QAEI,oBAAoB;QACpB,UAAU;IACd;IACA;QACI,qCAAqC;IACzC;IACA;QACI,gCAAgC;QAChC,aAAa;IACjB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,6BAA6B;IACjC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,2BAA2B;QAC3B,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,2BAA2B;IAC/B;IACA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;;QAEI,gCAAgC;IACpC;IACA;QACI,WAAW;QACX,qFAAqF;IACzF;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,iCAAiC;IACrC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;EACF","sourcesContent":[".signup-form-panel__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    height: 150vh;\n    background-color: var( --white-color );\n}\n\n.signup-form-panel__container__left-col {\n    grid-area: left;\n    background-image: url(\"../../../../assets/images/baloa-background-login.png\");\n    height: 150vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.signup-form-panel__container__right-col {\n    grid-column: 6 / 12;\n    margin-top: 175px;\n    margin-bottom: 12px;\n}\n\n.signup-form-panel__container__right-col .baloa-headline-1 {\n    color: var(--primary-very-dark-color);\n    text-align: start;\n}\n\n.signup-form-panel__profile-photo {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.signup-form-panel__profile-photo .baloa-normal {\n    font-weight: var(--font-medium);\n    color: var(--primary-dark-color);\n    margin-top: var(--space-x2);\n    margin-bottom: var(--space-half);\n}\n\n.signup-form-panel__profile-photo_box{\n    position: relative;\n}\n\n.signup-form-panel__profile-photo__container {\n    width: 124px;\n    height: 124px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.signup-form-panel__profile-photo__container .hubicon-default_pp {\n    font-size: 124px;\n    color: var(--primary-dark-color);\n}\n\n.signup-form-panel__profile-photo__container_plus{\n    background-color: var(--new-green-color);\n    width: 31px;\n    height: 31px;\n    border-radius: 50%;\n    position: absolute;\n    top: 96px;\n    left: 90px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.signup-form-panel__profile-photo__container_plus.baloa-subtitle-2{\n    color: var(--white-color);\n    font-weight: var(--font-medium);\n}\n\n.signup-form-panel__profile-photo__container_plus:hover{\n    cursor: pointer;\n}\n\n.signup-form-panel__profile-photo__upload.baloa-names {\n    color: var(--new-green-color);\n    margin-top: var(--space-half-quarter);\n    cursor: pointer;\n}\n\n.signup-form-panel__form__first-last-name__container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.signup-form-panel__form__birth-day-username__container {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: var(--space);\n}\n\n.signup-form-panel__form__birth-day-username__container div {\n    width: 100%;\n}\n\n.signup-form-panel__form__birth-day-username__container__birth-day {\n    margin-left: var(--space-half-quarter);\n}\n\n.signup-form-panel__form__birth-day-username__container__username {\n    margin-right: var(--space-half-quarter);\n}\n\n.signup-form-panel__form__first-last-name__container .input-field {\n    width: 100%;\n}\n\n.signup-form-panel__form__first-last-name__container .input-field:first-of-type {\n    margin-right: var(--space-half-quarter);\n    margin-top: 72px;\n}\n\n.signup-form-panel__form__first-last-name__container .input-field:last-of-type {\n    margin-left: var(--space-half-quarter);\n    margin-top: 72px;\n}\n\n.signup-form-panel__form__first-last-name__container .input-field .input-field-input{\n    background-color: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 9px;\n}\n\n.signup-form-panel__form__first-last-name__container .input-field .input-field-label{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n    font-size: var(--space);\n}\n\n.input-field.signup-form-panel__form__username {\n    margin-bottom: var(--space-half-quarter);\n}\n\n.signup-form-panel__form__birth-day-username__container .input-field {\n    margin-top: var(--space-half-quarter);\n}\n\n.signup-form-panel__form__birth-day-username__container .input-field .input-field-input{\n    background-color: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 9px;\n}\n\n.signup-form-panel__form__birth-day-username__container .input-field .input-field-label{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n    font-size: var(--space); \n}\n\n\nbutton.button.primary-button.signup-form-panel__form__submit {\n    margin-left: auto;\n    margin-top: var(--space-x2);\n}\n\n.signup-form-panel__form__birth-day-username__container__username-tip.baloa-names {\n    color: var(--new-green-color);\n    font-weight: var(--font-regular);\n}\n\n.signup-form-panel__form__birth-day-username__container__username .baloa-names:last-of-type {\n        font-weight: var(--font-regular);\n}\n\n.signup-form-panel__profile-photo__container img {\n    width: 124px;\n    height: 124px;\n    border-radius: 50%;\n}\n\n.signup-form-panel__container__left-col img {\n    width: 181px;\n    margin-top: 68px;\n    margin-left: var(--space-x3);\n}\n.signup-form-panel__container__right_back-option{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: var(--space);\n}\n\n.signup-form-panel__form__role_container{\n    display: flex;\n    gap: var(--space-and-half);\n    justify-content: space-between;\n}\n\n.signup-form-panel__form__profile-role{\n    width: 50%;\n}\n\n.profile-role-selector__select-input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before {\n    border: none !important;\n}\n.profile-role-selector__select-input .MuiInput-underline.select-field-input:before {\n    border: none;\n    transition: none;\n}\n.profile-role-selector__select-input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused {\n    border-style: none !important;\n}\n\n.profile-role-selector__select-input .MuiListItemText-multiline .MuiListItemText-secondary {\n    display: none;\n}\n\n.profile-role-selector__select-input .MuiListItemText-multiline .baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.profile-role-selector__select-input .MuiSelect-select:focus {\n    background-color: unset;\n}\n\n.profile-role-selector__select-input .select-field-input,\n.profile-profession-selector__select-input .select-field-input{\n    background-color: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 9px;\n}\n\n.profile-profession-selector__select-input.input-field-autocomplete__list {\n    margin-left: 16px;\n    margin-top: 7px;\n    margin-bottom: 7px;\n}\n\n.signup-form-panel__form__profile-role .select-field.profile-role-selector__select-input{\n    margin: 0;\n}\n\n.profile-role-selector__select-input .select-field-clean__icon-list.icon-coach{\n    color: var(--primary-very-dark-color);\n}\n\n.signup-form-panel__form__profile-role .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root{\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 9px;\n}\n\n.signup-form-panel__form__profile-role .profile-profession-selector__select-input{\n    margin-top: 11px;\n}\n\n.signup-form-panel__form__profile-role .input-field-autocomplete label{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n    font-size: var(--space);\n    text-transform: inherit;\n}\n\n.signup-form-panel__form__profile-role_label_tooltip{\n    display: flex;\n    gap: var(--space-quarter);\n    align-items: center;\n}\n\n.signup-form-panel__form__profile-role_label_tooltip .label_tooltip.baloa-table{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.signup-form-panel__form__input_grid-tooltip{\n    display: flex;\n}\n\n.signup-form-panel_tooltip {\n    position: relative;\n    display: inline-block;\n}\n\n.signup-form-panel_tooltip .signup-form-panel_tooltiptext {\n    display:flex;\n    flex-direction: column;\n    align-items: flex-start;\n    visibility: hidden;\n    width: 20rem;\n    background: var(--white-color);\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 8px;\n    border-radius: 6px;\n    padding: 10px;\n    position: absolute;\n    left: -152px;\n    top: -192px;\n    z-index: 1;\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));\n}\n\n.signup-form-panel_tooltiptext .baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.signup-form-panel_tooltiptext .baloa-table{\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n    margin-left: var(--space-quarter);\n}\n\n.signup-form-panel_tooltiptext_grid_title{\n    display: flex;\n    align-items: baseline;\n}\n\n.signup-form-panel_tooltip:hover{\n    cursor: pointer;\n}\n\n.signup-form-panel_tooltip:hover .signup-form-panel_tooltiptext {\n    visibility: visible;\n}\n\n.signup-form-panel_tooltiptext::after{\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid var(--white-color);\n    transform: translateX(-50%);\n}\n\n.signup-form-panel__form__profile-role .MuiAutocomplete-listbox {\n    padding: 8px;\n}\n\n.signup-form-panel__form__claim-account-file {\n    margin-top: 24px;\n}\n\n.signup-form-panel__form__claim-account-file .baloa-names {\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.signup-form-panel__form__claim-account-file .baloa-table {\n    color: var(--basic-gray-color);\n    margin-top: 4px;\n}\n\n.signup-form-panel__form__claim-account-file .upload-file-button {    \n    border-radius: 6px;\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--white-color);\n    color: var(--new-green-color);\n    margin-right: 12px;\n}\n\n.upload-file-button .icon {\n    grid-area: icon;\n    margin-right: 10px;\n}\n\n.signup-form-panel__form__claim-account-file .hubicon-upload::before {\n    color: var(--new-green-color);\n}\n\n.signup-form-panel__form__claim-account-file .baloa-table-column {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.signup-form-panel__form__claim-account-file__button {\n    margin-top: 12px;\n    display: flex;\n    align-items: center;\n}\n\n.signup-form-panel__form__claim-account-file__button .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n}\n\n.signup-form-panel__form__claim-account-file__button .hubicon-clear_option {\n    background: var(--new-gray-color);\n    border-radius: 50%;\n    padding: 5px;\n    margin-left: 12px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .signup-form-panel__container {\n        display: block;\n        height: 100vh;\n    } \n    .signup-form-panel__container__left-col {\n        height: 0;\n        background-image: none;\n    }\n    .signup-form-panel__container__left-col a {\n        display: flex;\n        justify-content: center;\n    }\n    .signup-form-panel__container__left-col img {\n        width: 100px;\n        margin-top: calc( var(--space-x3) + var(--space-quarter) + var(--space-eighth) );\n        margin-left: 0;\n    }\n    .signup-form-panel__container__right-col {\n        margin-top: 0;\n        background-color: var(--white-color);\n        top: 117px;\n        position: absolute;\n        z-index: 1;\n        width: 100%;\n        padding-bottom: var(--space);\n    }    \n    .form.signup-form-panel__form {\n        \n        margin: var(--space);\n        width: 92%;\n    }\n    .signup-form-panel__container__right-col .baloa-headline-1 {\n        color: var(--primary-very-dark-color);\n    }\n    .signup-form-panel__profile-photo .baloa-normal {        \n        color: var(--primary-dark-color);\n        margin-top: 0;   \n    }\n    .signup-form-panel__profile-photo__container {\n        width: 80px;\n        height: 80px;        \n    }\n    .signup-form-panel__profile-photo__container .hubicon-default_pp {\n        font-size: 80px;\n    }\n    .signup-form-panel__profile-photo__upload.baloa-names {\n        margin-top: var(--space-half);\n    }\n    .signup-form-panel__form__first-last-name__container {\n        flex-direction: column;\n    }\n    .signup-form-panel__form__first-last-name__container .input-field:first-of-type {\n        margin-right: 0; \n        margin-top: var(--space-x3);\n        margin-bottom: 0;\n    }\n    .signup-form-panel__form__first-last-name__container .input-field:last-of-type {\n        margin-left: 0;\n        margin-top: var(--space-x3);\n    }\n    .signup-form-panel__form__birth-day-username__container {\n        flex-direction: column;\n        margin-bottom: 0;\n    }\n    .signup-form-panel__form__date-field .input-field-input  {\n        width: 100%;\n    }\n    .signup-form-panel__form__birth-day-username__container__username {\n        margin-left: 0;\n    }\n    .signup-form-panel__form__birth-day-username__container__username-tip.baloa-names,\n    .signup-form-panel__form__birth-day-username__container__username .baloa-names:last-of-type {\n        font-weight: var(--font-regular);\n    }\n    button.button.primary-button.signup-form-panel__form__submit {\n        width: 100%;\n        margin-top: calc( var(--space-x3) + var(--space-half-quarter) + var(--space-eighth) );\n    }\n    .signup-form-panel__profile-photo__container img {\n        width: 80px;\n        height: 80px;\n    }\n    .input-field.signup-form-panel__form__username {\n        margin-bottom: 0;\n    }\n    .signup-form-panel__container__right-_back-option{\n        margin-left: var(--space-half);\n    }\n    .signup-form-panel__profile-photo__container_plus{\n        width: 24px;\n        height: 24px;\n        top: 58px;\n        left: 56px;\n    }\n    .signup-form-panel__form__birth-day-username__container__birth-day {\n        margin-left: 0px;\n        margin-top: var(--space-and-half);\n    }\n    .signup-form-panel__form__birth-day-username__container__birth-day .input-field{\n        margin: var(--space) 0;\n    }\n    .signup-form-panel__form__role_container{\n        display: flex;\n        flex-direction: column;\n    }\n    .signup-form-panel__form__profile-role{\n        width: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
